import React, { useState } from 'react';
import { SearchPanel } from '../components/SearchPanel';
import { RequestDataTable } from '../components/RequestDataTable';
import { DataSourceCombobox } from '../components/DataSourceCombobox'
import logService from '../services/LogService'
import { useSelector, useDispatch } from "react-redux";
import { updateSearch, pushDetails, setServerInstance, updateEntries, updateLogPageNum, setCertificateLabel } from "../actions/searchAction";
import { useHistory } from "react-router-dom";
import { useIsAuthenticated } from "@azure/msal-react";


export const RequestLogs = () => {
  const [isSearching, setIsSearching] = useState(false);

  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const history = useHistory();
  const isAuthenticated = useIsAuthenticated();

  if (!isAuthenticated) {
    history.replace('/home');
    return null;
  }

  //TODO: move this code to the action handler
  const updateSearchModel = (e, currentSearchMode) => {
    console.log(`Updating handleSearchParamsChange ${Object.getOwnPropertyNames(e)}`);

    var newSearchModel = Object.assign({}, currentSearchMode);
    newSearchModel.authorityName = (e.authorityName !== undefined) ? e.authorityName : newSearchModel.authorityName;
    newSearchModel.requestDate = (e.requestDate !== undefined) ? e.requestDate : newSearchModel.requestDate;
    newSearchModel.requestId = (e.requestId !== undefined) ? e.requestId : newSearchModel.requestId;
    newSearchModel.patientDob = (e.patientDob !== undefined) ? e.patientDob : newSearchModel.patientDob;
    newSearchModel.patientFirstName = (e.patientFirstName !== undefined) ? e.patientFirstName : newSearchModel.patientFirstName;
    newSearchModel.patientLastName = (e.patientLastName !== undefined) ? e.patientLastName : newSearchModel.patientLastName;
    newSearchModel.topCount = (e.topCount !== undefined) ? e.topCount : newSearchModel.topCount;
    newSearchModel.desc = (e.desc !== undefined) ? e.desc : newSearchModel.desc;
    newSearchModel.serverInstance = (e.serverInstance !== undefined) ? e.serverInstance : state.instanceId;
    newSearchModel.dataSource = (e.dataSource !== undefined) ? e.dataSource : state.dataSource;
    return newSearchModel;
  }


  // Search logs for the search criteria
  const searchLogEntries = async (searchModel) => {
    console.log("searching for log entries")
    return logService.getList(searchModel);
  }

  // Download a specific request
  const getRequestDetails = async (dataSource, authorityId, requestId) => {
    console.log('Requesting details');
    return logService.getDetails(dataSource, authorityId, requestId);
  }

  // Download certificate for selected  row
  const handleDownloadCertificate = (dataSource, instanceId, authorityId, requestId, certType) => {
    console.log('Requesting certificate');
    logService.getCertificate(dataSource, instanceId, authorityId, requestId, certType);
  }

  // Download and display a request
  const handleShowRequestDetails = (dataSource, authorityId, requestId, certType) => {
    getRequestDetails(dataSource, authorityId, requestId)
      .then((data) => {
        if (data !== null) {
          dispatch(setCertificateLabel(certType));
          dispatch(pushDetails(data));
          history.push('/details');
        }
      })
      .catch((error) => {
        console.error(`Could not get products: ${error}`);
      });
  };

  // Save the current page
  const handlePageChange = page => {
    dispatch(updateLogPageNum(page));
  };

  // Handle a search request
  const handleSearchClick = (e) => {
    setIsSearching(true);
    searchLogEntries(state.searchModel)
      .then((data) => {
        dispatch(updateEntries(data));
        setIsSearching(false);
      })
      .catch((error) => {
        console.error(`Could not get request entries: ${error}`);
        dispatch(updateEntries([])); // Clear the table data on failure
        setIsSearching(false);
      });
  };

  // Call searchAction methods to update the state (note here we match the server instance to the data source)
  const handleChangeDataSource = (e) => {
    dispatch(setDataSource(e));
    dispatch(setServerInstance(e));
  }
  //const handleChangeServerInstance = (e) => dispatch(setServerInstance(e));
  const handleSearchChanges = (e) => dispatch(updateSearch(updateSearchModel(e, state.searchModel)));

  const searchButtonClass = (state.searchModel.authorityName !== '') ? 'btn btn-primary' : 'btn btn-primary disabled';
  const searchButtonEnabled = (state.searchModel.authorityName !== '') ? '' : 'disabled';

  return (
    <>
      <h1>Immucert Request Logs</h1>
      <div className='row'>
        <div className='col-md-6'>
          <p>Enter a search filter to view the logs.</p>
        </div>
        <div className='col-md-2 offset-md-2 '>
          <DataSourceCombobox
            dataSource={state.dataSource}
            onChangeState={handleChangeDataSource} />
        </div>
        <div className='col-md-2 btn-group'>
          <button
            className={searchButtonClass}
            disabled={searchButtonEnabled}
            onClick={handleSearchClick}>{isSearching ? 'Searching...' : 'Search'}</button>
        </div>
      </div>

      <SearchPanel
        style={{ zIndex: 1000 }}
        searchParams={state.searchModel}
        handleChangeProps={handleSearchChanges} />
      <br />
      <RequestDataTable
        isSearching={isSearching}
        data={state.data}
        currentPage={state.currentLogPage}
        serverInstance={state.serverInstance}
        dataSource={state.dataSource}
        onChangePage={handlePageChange}
        handleShowRequestDetails={handleShowRequestDetails}
        handleDownloadCertificate={handleDownloadCertificate}
      />
    </>
  );
}
